import { SET_LATEST_FOREX } from '../types';

const INITIAL_STATE = {
    latest: {
        zarTo: {
            usd: 0,
            eur: 0,
            zar: 1
        },
        usdTo: {
            usd: 1,
            eur: 0,
            zar: 0
        },
        eurTo: {
            usd: 0,
            eur: 1,
            zar: 0
        }
    }
}

const ZAR = 'ZAR';
const USD = 'USD';
const EUR = 'EUR';

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LATEST_FOREX:
            if(!action.payload)
                return { ...state };
            return {
                ...state,
                latest:
                {
                    zarTo: {
                        zar: 1,
                        usd: action.payload.find(x => x.from === ZAR && x.to === USD).rate,
                        eur: action.payload.find(x => x.from === ZAR && x.to === EUR).rate
                    },
                    usdTo: {
                        usd: 1,
                        zar: action.payload.find(x => x.from === USD && x.to === ZAR).rate,
                        eur: action.payload.find(x => x.from === USD && x.to === EUR).rate
                    },
                    eurTo: {
                        eur: 1,
                        usd: action.payload.find(x => x.from === EUR && x.to === USD).rate,
                        zar: action.payload.find(x => x.from === EUR && x.to === ZAR).rate
                    }
                }
            }
        default:
            return state;
    }
}
